export default __webpack_public_path__ + "static/media/keto_labels@2x.bf3ea8af.jpg";